<style>
.xlTextfield {
    font-size: 44px;
}

.xlTextfield input {
    font-size: 44px;
}
</style>

<template>
  <div v-if="currentMeterReadToEdit">
    <div>
      <v-card class="mx-auto elevation-0" tile>
        <v-container class="pt-0">
          <v-card-text class="pt-2"
                       v-touch="{
                                 left: ()=>
                        swipe('Left'),
                        right: () => swipe('Right')
                        }">

            <v-row no-gutters>
              <v-col cols="3">
                <div>Unit No</div>
              </v-col>
              <v-col cols="9">
                <div class="font-weight-bold text-md-h5 text-no-wrap text-truncate" style="font-size: large">
                  {{ currentMeterReadToEdit.location }}
                </div>
              </v-col>
            </v-row>

            <v-row no-gutters>
              <v-col cols="3">
                <div>Meter</div>
              </v-col>
              <v-col cols="9">
                <div class="font-weight-bold text-md-h5 text-truncate" style="font-size: large">
                  {{ currentMeterReadToEdit.meterCode }}
                </div>
              </v-col>
            </v-row>

            <v-row>
              <v-divider></v-divider>
            </v-row>
            
            <v-form ref="form" v-on:submit.prevent v-model="valid" class="mt-3 pt-1">
              <v-row no-gutters>
				<v-col cols="12">
                    <span class="text-md-h5">Enter Meter Read</span>
                </v-col>
				<v-col cols="11">
					<v-text-field ref="inputRead" label="" type="number"
								v-model.number="currentMeterReadToEdit['meterRead']"
								step="any" class="xlTextfield mt-0 pt-0 " height="64">
                    </v-text-field>
				</v-col>
                <v-col cols="1" class="text-center">
					<v-btn icon
						large
						:color="hasImageOrUrl ? 'green accent-4' : 'grey darken-2'"
						@click="showMeterReadImageDialog()">
						<v-icon v-if="hasImageOrUrl">mdi-camera-plus</v-icon>
						<v-icon v-else>mdi-camera-plus-outline</v-icon>
					</v-btn>
                </v-col>
                <v-col cols="5">
                    <div class="text--primary"><b>Last</b>: {{ currentMeterReadToEdit.lastRead }}</div>
                    <div class="text--primary">{{ dayJS(currentMeterReadToEdit.lastReadDate).format('DD/MM/YYYY') }}</div>
                </v-col>
                <v-col cols="2">
                  <v-btn icon
                         large
                         :color="'grey darken-2'"
                         @click="notesDialog = true">
                    <v-icon >mdi-note-outline</v-icon>
                  </v-btn>
                </v-col>
                <v-col cols="5">
                  <div class="text-right text--primary">
                    <b>Projected</b>:
                    {{ currentMeterReadToEdit.projectedRead }}
                  </div>
                </v-col>
                
              </v-row>
            </v-form>
          </v-card-text>

          <v-card-actions>
            <v-btn color="primary" 
                   large 
                   @click="previousItem()" 
                   style="width: 120px" 
                   outlined>
              Previous
            </v-btn>
            <v-spacer/>
            <div>
              <div>{{ currentMeterReadIndex + 1 }} of {{ meterReads.length }}</div>
            </div>
            <v-spacer/>
            <v-btn v-if="!isLastMeter" 
                   type="button" 
                   color="primary" 
                   large 
                   :disabled="!valid" 
                   @click="nextItem()" 
                   style="width: 120px">
              Next
            </v-btn>
            <v-btn v-else 
                   type="button" 
                   color="success" 
                   large 
                   :disabled="!valid" 
                   @click="finishReadings()" 
                   style="width: 120px">
              Finish
            </v-btn>
          </v-card-actions>
        </v-container>
      </v-card>

    </div>

    <v-dialog v-model="notesDialog"
              fullscreen
              hide-overlay
              transition="dialog-bottom-transition">
      <v-card>
        <v-card-title>
          <span class="text-h5">Meter Notes</span>
        </v-card-title>
        <v-card-text>
          <v-container fluid>
            <v-textarea ref="NotesTextArea"
                        placeholder="No meter notes"
                        v-model="meterNotes"
                        readonly
            ></v-textarea>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary"
                 large
                 @click="notesDialog = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="meterReadImageDialog"
              fullscreen
              hide-overlay
              transition="dialog-bottom-transition">
      <v-card>
        <v-card-title>
          <span class="text-h5">Take a Meter Read Photo</span>
        </v-card-title>
        <v-card-text>
          <v-container fluid>
            <template>
                <PhotoCaptureAndViewer 
                  :capturedImage="currentMeterReadToEdit.imageOrUrl" 
                  @update:capturedImage="$set(currentMeterReadToEdit, 'imageOrUrl', $event)"
                />
                <h3 class="text-center mt-8" v-if="showLoadImageNetworkErrorMessage">
                  -- Cannot load image while offline --
                </h3>
            </template>
            <div class="text-center" v-if="isGetImageSrcLoading">
              <v-progress-linear :size="70"
                                :width="7"
                                color="primary"
                                indeterminate/>
            </div>
          </v-container>
        </v-card-text>
        <v-card-actions style="background-color: white;position: fixed;bottom: 0;right:0">
            <v-spacer></v-spacer>
            <v-btn color="primary"
                    :disabled="!currentMeterReadToEdit.imageOrUrl && !currentMeterReadToEdit.imagePath"
                    text
                    large
                    @click="clearMeterReadImage()">
                Clear
            </v-btn>
            <v-btn color="primary"
                    large
                    @click="meterReadImageDialog = false">
                Close
            </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</div>
</template>

<script>
import {alertConfirm} from "@/utils/Alerts";
import dayJS from 'dayjs';
import { mapActions } from "vuex";
import { getImageFileUrl } from "@/providers/backendApiService";
import PhotoCaptureAndViewer from "./PhotoCaptureAndViewer.vue";

export default {
    name: "EnterRead",
    props: {
        currentMeterRead: Object,
        currentMeterReadIndex: Number,
        meterReads: Array
    },
    components: {
      PhotoCaptureAndViewer
    },
    data() {
        return {
            currentMeterReadToEdit: null,
            valid: true,
            notesDialog: false,
            meterReadImageDialog: false,
            dayJS,
            fileInputKey: 0,
            isGetImageSrcLoading: false,
            isNetworkError: false
        }
    },
    async mounted() {
        this.currentMeterReadToEdit = {
            ...JSON.parse(JSON.stringify(this.currentMeterRead)),
            imageOrUrl: this.currentMeterRead.imageOrUrl ?? null
        };
        this.focusReadInput();
    },
    computed: {
        meterNotes: {
            get() {
                if (this.currentMeterReadToEdit)
                    return this.currentMeterReadToEdit.meterNotes;
                return '';
            },
            set(newValue) {
                this.currentMeterReadToEdit.meterNotes = newValue;
            }
        },
        hasImageOrUrl(){
            return !!(this.currentMeterReadToEdit && (this.currentMeterReadToEdit.imagePath || this.currentMeterReadToEdit.imageOrUrl));
        },
        showLoadImageNetworkErrorMessage(){
          return this.isNetworkError && this.currentMeterReadToEdit.imagePath && !this.currentMeterReadToEdit.imageOrUrl
        },
        isLastMeter() {
            return this.currentMeterReadIndex >= this.meterReads.length - 1;
        }
    },
    watch: {
        currentMeterRead: {
            handler(currentMeterRead) {
                this.currentMeterReadToEdit = {
                    ...JSON.parse(JSON.stringify(currentMeterRead)),
                    imageOrUrl: currentMeterRead.imageOrUrl ?? null
                };
            },
            deep: true
        }
    },
    methods: {
        ...mapActions([
            'saveRead'
        ]),
        clearMeterReadImage() {
            this.currentMeterReadToEdit.imagePath = null;
            this.currentMeterReadToEdit.imageOrUrl = null;

            // Increment the key to reset the input
            this.fileInputKey++;
        },
        async getLastUploadedMeterReadImage() {
            if (this.currentMeterReadToEdit.imagePath) {
                try {
                    this.isGetImageSrcLoading = true
                    let response = await getImageFileUrl(this.currentMeterReadToEdit.imagePath)
                    this.currentMeterReadToEdit.imageOrUrl = response
                    this.isNetworkError = false
                } catch (error) {
                    console.error('Error fetching image:', error);
                    if(error.code == "ERR_NETWORK"){
                      this.isNetworkError = true
                    }
                }
                this.isGetImageSrcLoading = false
            }
        },
        showMeterReadImageDialog(){
            this.meterReadImageDialog = true;
            if(!this.currentMeterReadToEdit.imageOrUrl){
                this.getLastUploadedMeterReadImage();
            }
        },
        async nextItem() {
            if (!(await this.validOrConfirmedRead()))
                return;
            this.saveRead(this.currentMeterReadToEdit);
            this.$emit('nextItem');
            this.focusReadInput();
        },
        async finishReadings() {
            if (!(await this.validOrConfirmedRead()))
                return;
            this.saveRead(this.currentMeterReadToEdit);
            this.$emit('finished');
            this.focusReadInput();
        },
        async previousItem() {
            if (!(await this.validOrConfirmedRead()))
                return;
            this.saveRead(this.currentMeterReadToEdit);
            if (this.currentMeterReadIndex > 0) {
                this.$emit('previousItem');
            }
            this.focusReadInput();
        },
        swipe(direction) {
            if (direction === "Left" && this.valid) {
                this.nextItem();
            } else if (direction === "Right") {
                this.previousItem();
            }
        },
        focusReadInput() {
            this.$refs?.inputRead?.focus();
        },
        async validOrConfirmedRead() {
            let meterRead = this.currentMeterReadToEdit['meterRead'];
            let projectedRead = this.currentMeterReadToEdit['projectedRead'];
            if (!meterRead && meterRead !== 0) {
                return true;
            }
            if (meterRead >= projectedRead * 0.7 && meterRead <= projectedRead * 1.3) {
                return true;
            }

            let response = await alertConfirm('Check Read'
                , 'Meter reading is not within 30% tolerance level of the projected read. \n\n Confirm read of ' + meterRead + ' is correct.'
                , 'Confirm'
                , 'Change')
            return !!response.isConfirmed;
        }
    }
}
</script>

<style scoped>
</style>